var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('CompanyEmployeeList',{attrs:{"type":"instructor","title":_vm.$t('labels.instructor'),"isDepartments":_vm.hasDepartments(_vm.$route.params.id),"MessageBoxText":_vm.$t('company.department-instructor-info') +
      ' ' +
      _vm.getCurrentUserDepartments(_vm.$route.params.id, _vm.isAdministrator, false),"companyId":Number(_vm.$route.params.id)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }